import { useRecipientStatus } from '../model/hooks/useRecipientsStataus';

import { RecipientGroupsList, type RecipientGroupModel } from './RecipientGroupsList';
import Styles from './styles.module.scss';

import type { ActionModel } from '../../model/types/action.model';
import type { ActionStatusModel } from '../../model/types/actions-status.model';
import type { UserModel } from '@/features/Shared/users/model/types/users.model';

interface Props {
	row: ActionModel;
	users: Record<string, UserModel>;
	actionsStatusMap: Record<string, ActionStatusModel>;
}

export const ExpandedRowDetails = ({ row, users, actionsStatusMap }: Props) => {
	const { items } = useRecipientStatus(row.id, actionsStatusMap, users);

	return (
		<div className={Styles.detailsContainer}>
			{row.body && <p>{row.body}</p>}
			<RecipientGroupsList items={items as RecipientGroupModel[]} />
		</div>
	);
};
